import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CtaButton } from './ui/CtaButton';
import { Check, X, ArrowRight, Gift } from 'lucide-react';
export function OfferSection() {
  return <section className="w-full px-4 md:px-6" data-id="element-516">
      <div className="max-w-4xl mx-auto space-y-24" data-id="element-517">
        {/* What You Receive */}
        <FadeIn data-id="element-518">
          <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 md:p-12" data-id="element-519">
            <h2 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-520">
              Lo que recibes
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-521">
              <div className="space-y-4" data-id="element-522">
                <div className="flex gap-4" data-id="element-523">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-524">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-525" />
                  </div>
                  <div data-id="element-526">
                    <h3 className="font-bold text-white text-lg" data-id="element-527">
                      Manual del Dinero (ebook)
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-528">
                      Con capítulos profundos, ejemplos y ejercicios.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-529">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-530">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-531" />
                  </div>
                  <div data-id="element-532">
                    <h3 className="font-bold text-white text-lg" data-id="element-533">
                      Plan de implementación
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-534">
                      Paso a paso, sin teoría infinita.
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4" data-id="element-535">
                <div className="flex gap-4" data-id="element-536">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-537">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-538" />
                  </div>
                  <div data-id="element-539">
                    <h3 className="font-bold text-white text-lg" data-id="element-540">
                      Plantillas imprimibles
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-541">
                      Mapa del Dinero, Mapa de Cuentas, Tarjeta "Rol Definido".
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-542">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-543">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-544" />
                  </div>
                  <div data-id="element-545">
                    <h3 className="font-bold text-white text-lg" data-id="element-546">
                      Protocolo Anti-Crisis
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-547">
                      Qué hacer cuando el mundo se pone raro (sin decisiones
                      heroicas).
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Bonuses included */}
            <div className="mt-8 pt-8 border-t border-brand-gold/10" data-id="element-548">
              <div className="flex items-center gap-2 mb-6 justify-center" data-id="element-549">
                <Gift className="w-5 h-5 text-brand-gold" data-id="element-550" />
                <h3 className="text-xl font-bold text-white" data-id="element-551">
                  + 3 BONOS GRATIS INCLUIDOS
                </h3>
              </div>
              <div className="grid md:grid-cols-3 gap-4" data-id="element-552">
                <div className="bg-brand-bg/50 border border-brand-gold/10 rounded-xl p-5 text-center" data-id="element-553">
                  <div className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded inline-block mb-3" data-id="element-554">
                    GRATIS
                  </div>
                  <h4 className="font-bold text-white text-sm mb-1" data-id="element-555">BONO #1</h4>
                  <p className="text-brand-gold text-sm font-medium mb-2" data-id="element-556">
                    Kit "Cero Fricción"
                  </p>
                  <p className="text-brand-muted text-xs" data-id="element-557">
                    Configura tus 4 cuentas en 30 minutos con guías paso a paso.
                  </p>
                </div>
                <div className="bg-brand-bg/50 border border-brand-gold/10 rounded-xl p-5 text-center" data-id="element-558">
                  <div className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded inline-block mb-3" data-id="element-559">
                    GRATIS
                  </div>
                  <h4 className="font-bold text-white text-sm mb-1" data-id="element-560">BONO #2</h4>
                  <p className="text-brand-gold text-sm font-medium mb-2" data-id="element-561">
                    Guía "Anti-Mezcla"
                  </p>
                  <p className="text-brand-muted text-xs" data-id="element-562">
                    Reglas de transferencias y pagos automáticos para no volver
                    a mezclar.
                  </p>
                </div>
                <div className="bg-brand-bg/50 border border-brand-gold/10 rounded-xl p-5 text-center" data-id="element-563">
                  <div className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded inline-block mb-3" data-id="element-564">
                    GRATIS
                  </div>
                  <h4 className="font-bold text-white text-sm mb-1" data-id="element-565">BONO #3</h4>
                  <p className="text-brand-gold text-sm font-medium mb-2" data-id="element-566">
                    Workbook "Ansiedad → Acción"
                  </p>
                  <p className="text-brand-muted text-xs" data-id="element-567">
                    Protocolo de 10 minutos para frenar impulsos financieros.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Who it is for */}
        <FadeIn data-id="element-568">
          <h2 className="text-3xl font-bold text-white mb-10 text-center" data-id="element-569">
            Para quién es (y para quién no)
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-570">
            {/* YES */}
            <div className="bg-brand-green/5 border border-brand-green/20 rounded-xl p-8" data-id="element-571">
              <h3 className="text-brand-green font-bold text-xl mb-6 flex items-center gap-2" data-id="element-572">
                <Check className="w-6 h-6" data-id="element-573" /> Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-574">
                {['Emprendes o trabajas por tu cuenta en Latinoamérica', 'Tus ingresos son variables o irregulares', 'Te afecta el ruido del dólar/noticias/tasas', 'Sientes que te falta control, no ganas', 'Quieres reglas simples, no motivación'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-575">
                    <Check className="w-4 h-4 text-brand-green mt-1 shrink-0" data-id="element-576" />
                    <span data-id="element-577">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* NO */}
            <div className="bg-brand-red/5 border border-brand-red/20 rounded-xl p-8" data-id="element-578">
              <h3 className="text-brand-red font-bold text-xl mb-6 flex items-center gap-2" data-id="element-579">
                <X className="w-6 h-6" data-id="element-580" /> No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-581">
                {["Buscas 'la inversión del año'", 'Quieres trading o promesas de rendimiento', 'Quieres predicciones geopolíticas', 'Te molesta hacerte responsable de tus reglas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-582">
                    <X className="w-4 h-4 text-brand-red mt-1 shrink-0" data-id="element-583" />
                    <span data-id="element-584">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>

        {/* Transformation */}
        <FadeIn data-id="element-585">
          <div className="text-center max-w-2xl mx-auto" data-id="element-586">
            <h2 className="text-3xl font-bold text-white mb-8" data-id="element-587">
              La transformación
            </h2>
            <p className="text-lg text-brand-muted mb-10" data-id="element-588">
              No te prometo que el mundo se calme. Te prometo algo más útil:{' '}
              <br data-id="element-589" />
              <span className="text-white" data-id="element-590">
                Que tu dinero deje de ser un lugar donde se pelean tus
                emociones.
              </span>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-591">
              {[{
              from: 'Improvisar',
              to: 'Ejecutar'
            }, {
              from: 'Reaccionar',
              to: 'Decidir'
            }, {
              from: 'Mezclar',
              to: 'Separar'
            }, {
              from: 'Urgencia',
              to: 'Criterio'
            }].map((item, i) => <div key={i} className="flex items-center justify-between bg-brand-card p-4 rounded border border-brand-bg" data-id="element-592">
                  <span className="text-brand-muted" data-id="element-593">{item.from}</span>
                  <ArrowRight className="w-4 h-4 text-brand-gold" data-id="element-594" />
                  <span className="text-white font-bold" data-id="element-595">{item.to}</span>
                </div>)}
            </div>

            <p className="text-lg text-white font-serif italic mb-8" data-id="element-596">
              "Y cuando el entorno se mueva, tú vas a tener una ventaja: no vas
              a estar tomando decisiones desde el pánico."
            </p>

            <div className="flex justify-center" data-id="element-597">
              <CtaButton onClick={() => document.getElementById('final-cta')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-598">
                Quiero el Manual del Dinero
              </CtaButton>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}